import axios from 'axios';
import { pick } from 'lodash';
import { PageModel } from 'survey-core/survey.core';
import { IProgressEventPayload } from '../types/events';
import { Model } from 'survey-core';
import { SELF_SERVE_VALUE } from '../components/questionTypes/MuiAdditionalProducts';
import { CompanyLocation, ComplianceLevels, MembershipTypes } from '../types/enums';
import { OperationType } from '../types/companyDetails';

type CustomPageModel = PageModel & {
  stepName: string;
  completePage?: boolean;
};

export const updateLead = async (
  model: Model,
  data: any,
  stepNumber: number,
  accountId?: string,
  completing?: boolean
) => {
  try {
    const productIds = Object.values(pick(data, ['subscription', 'additionalProduct'])).filter(
      productId => productId && productId !== SELF_SERVE_VALUE
    );
    const productCodes = productIds.map(productId =>
      model.runExpression(`expandChoicesByUrl('${productId}', productCode)`)
    );
    if (data.subscription && model.runExpression('getJoiningFee()') > 0) {
      productIds.push(model.runExpression("getJoiningFee('id')"));
      productCodes.push(model.runExpression("getJoiningFee('productCode')"));
    }

    const eliteChosen =
      data.subscription &&
      model.runExpression(`expandChoicesByUrl('${data.subscription}', subscriptionTier)`) === ComplianceLevels.Elite;
    const page = model.visiblePages[stepNumber - 1] as CustomPageModel;
    const orderPage = Boolean(page?.completePage);
    const discount = model.getVariable('discount');
    const company = model.getVariable('company');
    const isAdmin = model.getVariable('isAdmin');
    const operationType = model.getVariable('signupType');
    const GBElitePackage = eliteChosen && data['packageType'] === CompanyLocation.GB;
    const isFoundation = operationType === OperationType.FOUNDATION;

    const body: IProgressEventPayload = {
      operationType,
      accountId,
      stepNumber,
      stepName: page.stepName,
      company: {
        ...pick(data, [
          'companyName',
          'country',
          'address1',
          'address2',
          'townOrCity',
          'postalCode',
          'totalEmployeeCount',
          'subcontractorEmployeeCount',
          'dataSharingConsent',
          'privacyConsent'
        ]),
        ...(orderPage && { dataSharingConsent: GBElitePackage ? Boolean(data.dataSharingConsent) : null }),
        ...(data['packageType'] === CompanyLocation.GB
          ? { companyHouse: company?.id }
          : { abn: company?.abn, acn: company?.acn })
      },
      user: {
        ...pick(data, ['firstName', 'lastName', 'email', 'phoneNumber']),
        email: data.email.trim()
      },
      package: {
        ...pick(data, ['applicationType', 'assessmentType']),
        location: data['packageType'],
        companyType: isFoundation ? MembershipTypes.Contractor : data['organizationType'],
        productCodes,
        productIds,
        discountCode: discount && data['discountCode'],
        clientId: discount?.clientId
      }
    };

    const response = await axios.post<string>('/api/v1/signup/progress', body, {
      params: { isAdmin: (isAdmin && !completing) || undefined }
    });
    return response.data;
  } catch (e) {
    throw e;
  }
};
